"use strict";

var angular = require("angular");
var moment = require("moment");

module.exports = [
    "residents.service",
    "notification.service",
    "modalConfig",
    function (residentsService, notification, modalConfig) {
        var vm = this;
        vm.residentId = modalConfig.residentId;
        vm.mode = modalConfig.mode;
        vm.currentDailyRateEnteralFeedingBolus = modalConfig.finance.currentDailyRateEnteralFeedingBolus;
        vm.currentDailyRateEnteralFeedingNonBolus = modalConfig.finance.currentDailyRateEnteralFeedingNonBolus;
        vm.supplement = angular.extend({}, modalConfig.finance.supplementEnteralFeeding);

        vm.bindHide = function ($hide) {
            vm.$hide = $hide;
        };

        vm.getDailyRate = function () {
            if (vm.supplement.bolus === true) {
                return vm.currentDailyRateEnteralFeedingBolus;
            }
            if (vm.supplement.bolus === false) {
                return vm.currentDailyRateEnteralFeedingNonBolus;
            }
            return "";
        };

        vm.getMinEndDate = function() {
            return moment(vm.supplement.startDateUtc).add(1, "day").startOf('day');
        };

        vm.getDuration = function() {
            if (!vm.supplement.endDateUtc) {
                return "";
            }
            var days = moment(vm.supplement.endDateUtc).startOf('day').diff(moment(vm.supplement.startDateUtc).startOf('day'), "days");
            if (days > 1) {
                return days.toString() + " days";
            }
            if (days === 1) {
                return "1 day";
            }
            if (days === 0) {
                return "0 days";
            }
            return "";
        };

        vm.save = function (isvalid) {
            if (isvalid) {
                if (vm.mode === "end") {
                    residentsService.endSupplementEnteralFeeding(vm.residentId, vm.supplement).then(
                    function (data) {
                        modalConfig.finance.supplementEnteralFeeding = null;
                        modalConfig.finance.supplementEnteralFeedingPreviousEntries = true;
                        vm.$hide();
                    },
                    function () {
                        notification.error("Unexpected error while saving Enteral Feeding details.");
                    });
                } else {
                    residentsService.saveSupplementEnteralFeeding(vm.residentId, vm.supplement).then(
                        function (data) {
                            modalConfig.finance.supplementEnteralFeeding = angular.extend({}, vm.supplement, { id: data.result });
                            vm.$hide();
                        },
                        function () {
                            notification.error("Unexpected error while saving Enteral Feeding details.");
                        });
                }
            }
        };

    }
];
